module.exports = __webpack_public_path__ + "media/images/flags/4x3/ton-6678aeed124ad82b10df77868aba0b3c.svg";